import { EarningRuleErrorHandleField } from 'components/earning/EarningRuleHandleError';
import { REWARD_AMOUNT_TYPE } from 'components/earning/RewardAmountInputArea';
import {
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE,
  EarningRuleRewardType,
  EarningRuleType,
  LanguageConfig,
} from 'config/CustomEnums';
import { CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';
import { validateRecurringPeriod } from 'containers/engagement/campaign/RecurringDateValidate'
import { isEmpty } from 'utils/StringUtil';

function firstStepValidate({ getValues, setError }) {
  const { linkedStampCampaign, type } = getValues();
  let errorMessage = '';
  if (linkedStampCampaign) {
    switch (type) {
      case EarningRuleType.newMember:
        errorMessage = 'New member does not support stamp campaign.';
        break;
      case EarningRuleType.birthday:
        errorMessage = 'Birthday does not support stamp campaign.';
        break;
      case EarningRuleType.levelUpgrade:
        errorMessage = 'Level upgrade does not support stamp campaign.';
        break;
      case EarningRuleType.fillingForm:
        errorMessage = EarningRuleErrorHandleField.linkStampCampaign.message;
        break;
      default:
        errorMessage = '';
        break;
    }
  }
  if (errorMessage) {
    setError('linkedStampCampaign', {
      type: 'manual',
      message: errorMessage,
    });

    return false;
  }
  return true;
}

function secondStepValidate({ getValues, setError }) {
  const [enGeneralName] = getValues([
    `translations.${LanguageConfig.english}.generalName`,
  ]);
  const errorList = [];
  if (
    !enGeneralName || enGeneralName.length > 200
  ) {
    errorList.push({
      name: 'generalName',
      message: EarningRuleErrorHandleField.generalName.message,
    });
  }
  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

const isEmptyOrLowerThanZero = (value) => {
  if (isEmpty(value)) {
    return true
  }
  if (value <= 0) {
    return true
  }
  return false
}

const isZero = (value) => {
  return value === 0 || value === '0';
};

function pointRewardTypeValidate(
  getValues,
  errorList,
  prefix = "",
) {
  const [
    earningType,
    quantity,
    tpeQuantity,
    rewardAmountType,
    pointTypeRewardPerXValue,
    tpeTypeRewardPerXValue,
    pointTypeRewardPerX,
    tpeTypeRewardPerX,
  ] = getValues([
    `${prefix}type`,
    `${prefix}quantity`,
    `${prefix}tpeQuantity`,
    `${prefix}rewardAmountType`,
    `${prefix}pointTypeRewardPerXValue`,
    `${prefix}tpeTypeRewardPerXValue`,
    `${prefix}pointTypeRewardPerX`,
    `${prefix}tpeTypeRewardPerX`,
  ]);
  if (earningType !== EarningRuleType.generalPurchase) {
    if (!quantity && !tpeQuantity) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}pointReward`,
        message: EarningRuleErrorHandleField['pointReward'].message,
      });
    }
    return
  }

  let generalPurchaseRewardHaveError = false;

  if (rewardAmountType === REWARD_AMOUNT_TYPE.dynamic) {
    if (
      isEmptyOrLowerThanZero(pointTypeRewardPerX)
      && isEmptyOrLowerThanZero(pointTypeRewardPerXValue)
      && isEmptyOrLowerThanZero(tpeTypeRewardPerX)
      && isEmptyOrLowerThanZero(tpeTypeRewardPerXValue)
    ) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}dynamicTpeReward`,
        message: EarningRuleErrorHandleField['pointReward'].message,
      });
      generalPurchaseRewardHaveError = true;
    }
    if (
      (isEmptyOrLowerThanZero(pointTypeRewardPerX) && !isEmptyOrLowerThanZero(pointTypeRewardPerXValue))
      || (isEmptyOrLowerThanZero(pointTypeRewardPerXValue) && !isEmptyOrLowerThanZero(pointTypeRewardPerX))
    ) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}dynamicPointReward`,
        message: EarningRuleErrorHandleField.point.message,
      });
      generalPurchaseRewardHaveError = true;
    }
    if (
      (isEmptyOrLowerThanZero(tpeTypeRewardPerX) && !isEmptyOrLowerThanZero(tpeTypeRewardPerXValue))
      || (isEmptyOrLowerThanZero(tpeTypeRewardPerXValue) && !isEmptyOrLowerThanZero(tpeTypeRewardPerX))
    ) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}dynamicTpeReward`,
        message: EarningRuleErrorHandleField.tpe.message,
      });
      generalPurchaseRewardHaveError = true;
    }
  } else {
    if (isEmptyOrLowerThanZero(pointTypeRewardPerXValue) && isEmptyOrLowerThanZero(tpeTypeRewardPerXValue)) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}tpeTypeRewardPerXValue`,
        message: EarningRuleErrorHandleField['pointReward'].message,
      });
      generalPurchaseRewardHaveError = true;
    }
  }

  if (generalPurchaseRewardHaveError) {
    errorList.push({
      sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
      name: 'displayRewardAmount',
      message: EarningRuleErrorHandleField['pointReward'].message,
    });
  }
}

function couponRewardTypeValidate(
  getValues,
  errorList,
  prefix = "",
  isCampaignStreamLine = false,
) {
  const [
    earningType,
    quantity,
    couponTemplate,
    rewardAmountType,
    couponTypeRewardPerX,
    couponTypeRewardPerXValue,
  ] = getValues([
    `${prefix}type`,
    `${prefix}quantity`,
    `coupons`,
    `${prefix}rewardAmountType`,
    `${prefix}couponTypeRewardPerX`,
    `${prefix}couponTypeRewardPerXValue`,
  ]);
  if (!isCampaignStreamLine && !couponTemplate) {
    errorList.push({
      sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
      name: 'coupons',
      message: EarningRuleErrorHandleField['coupons'].message,
    });
  }
  if (earningType !== EarningRuleType.generalPurchase) {
    if (isEmptyOrLowerThanZero(quantity)) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}quantity`,
        message: EarningRuleErrorHandleField['quantity'].message,
      });
    }
    return;
  }

  if (rewardAmountType === REWARD_AMOUNT_TYPE.oneOff) {
    if (isEmptyOrLowerThanZero(couponTypeRewardPerXValue)) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}couponTypeRewardPerXValue`,
        message: 'Coupons fields are not filled correctly.',
      });
    }
    return
  }

  if (rewardAmountType === REWARD_AMOUNT_TYPE.dynamic) {
    if (isEmptyOrLowerThanZero(couponTypeRewardPerX) || isEmptyOrLowerThanZero(couponTypeRewardPerXValue)) {
      errorList.push({
        sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.reward.sectionKey,
        name: `${prefix}dynamicCouponReward`,
        message: 'Coupons fields are not filled correctly.',
      });
    }
  }
}

const stampRewardTypeValidate = (
  getValues,
  errorList,
  prefix= "",
) => {
  const [
    earningType,
    rewardAmountType,
    stampTypeRewardPerX,
    stampTypeRewardPerXValue,
  ] = getValues([
    `${prefix}type`,
    `${prefix}rewardAmountType`,
    `${prefix}stampTypeRewardPerX`,
    `${prefix}stampTypeRewardPerXValue`,
  ]);
  if (earningType !== EarningRuleType.generalPurchase) {
    return;
  }
  if (rewardAmountType === REWARD_AMOUNT_TYPE.oneOff) {
    if (isEmptyOrLowerThanZero(stampTypeRewardPerXValue)) {
      errorList.push({
        name: `${prefix}stampTypeRewardPerXValue`,
        message: 'Stamps field is not filled correctly.',
      });
    }
    return;
  }
  if (rewardAmountType === REWARD_AMOUNT_TYPE.dynamic) {
    if (isEmptyOrLowerThanZero(stampTypeRewardPerX) || isEmptyOrLowerThanZero(stampTypeRewardPerXValue)) {
      errorList.push({
        name: `${prefix}dynamicStampReward`,
        message: 'Stamps fields are not filled correctly.',
      });
    }
    return
  }
}

function recurringDateValidate({ getValues, errorList }) {
  const [
    isInBirthMonth,
    type,
    recurringDate,
  ] = getValues([
    'isInBirthMonth',
    "type",
    'recurringDate',
  ]);
  if (!recurringDate) {
    return
  }
  if (type != EarningRuleType.generalPurchase && type != EarningRuleType.birthday) {
    return
  }
  if (type == EarningRuleType.generalPurchase && !isInBirthMonth) {
    return
  }
  validateRecurringPeriod({ isActive: true, isStart: true, recurringDate, errorList })
  validateRecurringPeriod({ isActive: true, isStart: false, recurringDate, errorList })
}

function lineItemGroupsValidate({ getValues, errorList, prefix = "" }) {
  const [
    lineItemGroups,
  ] = getValues([
    `${prefix}lineItemGroups`,
  ]);
  console.log("@@363", lineItemGroups)

  if (!lineItemGroups || !lineItemGroups.length) {
    return;
  };

  lineItemGroups.forEach((group, index) => {
    if (!group?.requirements || !group?.requirements?.length) {
      return;
    }

    group.requirements.forEach((requirement, subIndex) => {
      const fieldType = requirement?.fieldType;
      const formErrorId = `${prefix}lineItemGroups.${index}.requirements.${subIndex}.error`;
      if ([
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.brand,
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.category,
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.subcategory,
      ].includes(fieldType)
      ) {
        if (!requirement?.data?.pk) {
          errorList.push({
            sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.requirements.sectionKey,
            name: formErrorId,
            message: "Please select",
          });
          return;
        }
      };

      if ([
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData,
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData,
      ].includes(fieldType)
      ) {
        if (
          !requirement?.data?.field?.pk
          || !requirement?.data?.value
        ) {
          errorList.push({
            sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.requirements.sectionKey,
            name: formErrorId,
            message: "Please provide title and value",
          });
          return;
        }
      };

      if (fieldType === EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku) {
        if (!requirement?.data) {
          errorList.push({
            sectionKey: CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.requirements.sectionKey,
            name: formErrorId,
            message: "Please provide one sku",
          });
          return;
        }
      };
    });
  });
}

export const validateEarningPage = ({ getValues, prefix = "", isCampaignStreamLine = false }) => {
  const [
    type,
    rewardType,
    requirePromotionCode,
  ] = getValues([
    `${prefix}type`,
    `${prefix}rewardType`,
    `${prefix}requirePromotionCode`,
  ]);

  console.log("@@436", getValues(), type, rewardType, requirePromotionCode);

  let requiredFieldsConfig = {
    general_purchase: ['executionPriority'],
    gps_check_in: ['latitude', 'longitude', 'radius'],
    birthday: ['executionPriority'],
    new_member: ['executionPriority'],
    member_referral: ['executionPriority'],
    qr_code_scanning: ['qrCodes'],
    filling_form: ['executionPriority'],
    level_upgrade: ['levelGoal', 'executionPriority'],
  };
  if (type === EarningRuleType.newMember && requirePromotionCode) {
    requiredFieldsConfig = {
      ...requiredFieldsConfig,
      new_member: [...requiredFieldsConfig?.new_member || [], "promotionCode"]
    }
  }
  const requiredFields = [
    ...requiredFieldsConfig[type.toLowerCase()],
  ];
  const errorList = [];
  requiredFields.forEach((field, index) => {
    const sectionKey = field === 'executionPriority'
      ? CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.executionPriority.sectionKey
      : CAMPAIGN_EARNING_RULE_PAGE_ANCHOR_KEY.requirements.sectionKey
    const prefixField = `${prefix}${field}`;
    if (
      !getValues(prefixField) ||
      getValues(prefixField).length <= 0
    ) {
      errorList.push({
        sectionKey,
        name: prefixField,
        message: EarningRuleErrorHandleField[field].message,
      });
    }

    if (['latitude', 'longitude'].includes(field)) {
      const dataField = getValues(prefixField) + '';
      if (dataField.split('.')[0].length > 3) {
        errorList.push({
          sectionKey,
          name: prefixField,
          message: EarningRuleErrorHandleField[field].message,
        });
      }
    }
  });
  if (rewardType === EarningRuleRewardType.points) {
    pointRewardTypeValidate(
      getValues,
      errorList,
      prefix
    );
  }
  if (rewardType === EarningRuleRewardType.coupons) {
    couponRewardTypeValidate(getValues, errorList, prefix, isCampaignStreamLine);
  }
  if (rewardType === EarningRuleRewardType.stamps) {
    stampRewardTypeValidate(getValues, errorList, prefix)
  }

  if (type === EarningRuleType.generalPurchase) {
    lineItemGroupsValidate({ getValues, errorList, prefix });
  };

  return errorList;
};

function thirdStepValidate({ getValues, setError }) {
  const errorList = validateEarningPage({
    getValues,
    prefix: "",
  })

  const [
    type,
    linkedStampCampaign,
    rewardType,
    activeStartDate,
    activeEndDate,
    isAlwaysActivePeriod,
  ] = getValues([
    'type',
    'linkedStampCampaign',
    'rewardType',
    'activeStartDate',
    'activeEndDate',
    'isAlwaysActivePeriod',
  ]);

  if (rewardType === EarningRuleRewardType.stamps) {
    stampRewardTypeValidate(getValues, errorList);
  }
  if (
    [
      EarningRuleType.newMember,
      EarningRuleType.birthday,
      EarningRuleType.levelUpgrade,
      EarningRuleType.fillingForm,
    ].includes(type) ||
    (
      type === EarningRuleType.generalPurchase
      && !linkedStampCampaign
    )
  ) {
    if (
      !isAlwaysActivePeriod &&
      activeStartDate?.getTime() >= activeEndDate?.getTime()
    ) {
      errorList.push({
        name: 'activeEndDate',
        message: EarningRuleErrorHandleField.activeEndDate.message,
      });
    }
  }
  recurringDateValidate({ getValues, errorList })

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

export function validate({ getValues, setError, clearErrors, step, isBack }) {
  if (isBack) {
    return true;
  }
  clearErrors();
  switch (step) {
    case 0:
      const validStepOne = firstStepValidate({ getValues, setError });
      return validStepOne;
    case 1:
      const validStepTwo = secondStepValidate({ getValues, setError });
      return validStepTwo;
    case 2:
      const validStepThree = thirdStepValidate({ getValues, setError });
      return validStepThree;
    default:
      const validOne = firstStepValidate({ getValues, setError });
      const validTwo = secondStepValidate({ getValues, setError });
      const validThree = thirdStepValidate({ getValues, setError });
      return validOne && validTwo && validThree;
  }
}
